import { useDisclosure } from '@chakra-ui/react';
import { useMemo } from 'react';

import { trpc, TrpcOutputs } from '../../config/trpc';

export type DuplicateRequest = TrpcOutputs['getRelatedRequests']['duplicate'][0];

export const useRelatedRequests = (id: number, maxPreview = 5) => {
  const disclosure = useDisclosure();

  const { data: related, isFetching: isLoading } = trpc.getRelatedRequests.useQuery(
    { id },
    {
      enabled: !!id,
    },
  );

  const { hasSimilar, hasDuplicates, hasRelated, sampleList, remaining } = useMemo(() => {
    const hasSimilar = related?.similar?.length > 0;
    const hasDuplicates = related?.duplicate?.length > 0;
    const hasRelated = hasSimilar || hasDuplicates;

    const sampleList = hasDuplicates ? related?.duplicate : related?.similar;

    const remaining =
      Math.max(sampleList?.length - maxPreview, 0) + (hasDuplicates ? related?.similar?.length ?? 0 : 0);

    return {
      hasSimilar,
      hasDuplicates,
      hasRelated,
      sampleList,
      remaining,
    };
  }, [related?.duplicate, related?.similar, maxPreview]);

  return {
    hasRelated,
    hasSimilar,
    hasDuplicates,

    related,
    sampleList,
    maxPreview,
    remaining,

    disclosure,
    isLoading,
  };
};
